import styled from 'styled-components';
import { Container } from '@material-ui/core';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const SSubscriptionForm = styled.div`
  min-height: calc(100vh - ${p => `${p.theme.headerHeight}px`});

  display: flex;
  flex-direction: column;
`;

export const SMainContainer = styled(Container)`
  padding-top: 24px;

  flex: 1;
  height: 100%;

  display: flex;
  flex-direction: column;

  .main-info-wrapper {
    flex: 1;
  }

  .plan-info-wrapper {
    flex: 0;
  }

  ${breakpoints.down('sm')} {
    padding-left: 0;
    padding-right: 0;
  }

  ${breakpoints.up('md')} {
    padding-top: 32px;
    flex-direction: row-reverse;

    border-radius: 8px;

    .main-info-wrapper {
      margin-left: 350px;
    }
  }
`;

export default SSubscriptionForm;
